export function subscriptionPlanUuid(value: unknown): string | null {
  return typeof value === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)
    ? value.toLowerCase()
    : null;
}

export function subscriptionSelectionHref(slug: string, planUuid: string, authenticated: boolean): string {
  const plan = subscriptionPlanUuid(planUuid);
  const catalog = `/${encodeURIComponent(slug)}/subscriptions`;
  if (!plan) return catalog;
  return authenticated
    ? `${catalog}?${new URLSearchParams({ plan })}`
    : `/auth/start?${new URLSearchParams({ slug, section: "subscriptions", plan })}`;
}
